import { PiggyBank, Target, CircleDot } from 'lucide-react'
import { useApi } from '../../hooks/useApi'

interface SavingsData {
  cacheHits: number
  cacheMisses: number
  hitRate: number
  estimatedSavings: number
  periodDays: number
}

function Skeleton() {
  return <div className="animate-pulse bg-[#E2E4ED] rounded h-8 w-24" />
}

export default function GlobalDbSavings() {
  const { data, loading } = useApi<SavingsData>('/api/admin/global-db/savings?days=30')

  const hitRateColor = data && data.hitRate > 50 ? '#10B981' : '#F97316'

  return (
    <div className="bg-white rounded-xl border border-[#E2E4ED] p-5">
      <h2 className="text-lg font-semibold text-[#1B2559] mb-4">Economies (30 jours)</h2>

      <div className="grid grid-cols-2 gap-4">
        {/* Hit Rate */}
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: `${hitRateColor}14` }}>
            <Target size={18} strokeWidth={1.25} style={{ color: hitRateColor }} />
          </div>
          <div>
            {loading ? (
              <Skeleton />
            ) : (
              <p className="text-2xl font-bold" style={{ color: hitRateColor }}>
                {data ? `${data.hitRate.toFixed(1)}%` : '-'}
              </p>
            )}
            <p className="text-sm text-[#8B8FA7]">Hit Rate</p>
          </div>
        </div>

        {/* Estimated Savings */}
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: '#10B98114' }}>
            <PiggyBank size={18} strokeWidth={1.25} style={{ color: '#10B981' }} />
          </div>
          <div>
            {loading ? (
              <Skeleton />
            ) : (
              <p className="text-2xl font-bold text-[#10B981]">
                {data ? `${data.estimatedSavings.toFixed(2)} €` : '-'}
              </p>
            )}
            <p className="text-sm text-[#8B8FA7]">Economies estimees</p>
          </div>
        </div>

        {/* Cache Hits */}
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: '#10B98114' }}>
            <CircleDot size={18} strokeWidth={1.25} style={{ color: '#10B981' }} />
          </div>
          <div>
            {loading ? (
              <Skeleton />
            ) : (
              <p className="text-2xl font-bold text-[#1B2559]">
                {data?.cacheHits?.toLocaleString('fr-FR') ?? '-'}
              </p>
            )}
            <p className="text-sm text-[#8B8FA7]">Cache Hits</p>
          </div>
        </div>

        {/* Cache Misses */}
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: '#F9731614' }}>
            <CircleDot size={18} strokeWidth={1.25} style={{ color: '#F97316' }} />
          </div>
          <div>
            {loading ? (
              <Skeleton />
            ) : (
              <p className="text-2xl font-bold text-[#1B2559]">
                {data?.cacheMisses?.toLocaleString('fr-FR') ?? '-'}
              </p>
            )}
            <p className="text-sm text-[#8B8FA7]">Cache Misses</p>
          </div>
        </div>
      </div>
    </div>
  )
}
